import { render, staticRenderFns } from "./UDCField.vue?vue&type=template&id=5f5a5b31&"
import script from "./UDCField.vue?vue&type=script&lang=js&"
export * from "./UDCField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports